// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_EDIT_FILLOUT_MISSING_PROPS = "Pros\u00edm, dopl\u0148 si chyb\u011bj\u00edc\u00ed vlastnosti inzer\u00e1tu";
export const EDIT_PRODUCT_SUBMIT_BUTTON = "Ulo\u017e inzer\u00e1t";
